import { render, staticRenderFns } from "./ProductSortingModal.vue?vue&type=template&id=28be4be8&scoped=true"
import script from "./ProductSortingModal.vue?vue&type=script&lang=ts"
export * from "./ProductSortingModal.vue?vue&type=script&lang=ts"
import style0 from "./ProductSortingModal.vue?vue&type=style&index=0&id=28be4be8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be4be8",
  null
  
)

export default component.exports